/* eslint-disable complexity */
/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes, { element, object } from 'prop-types';
import cn from 'classnames';
import { t } from 'i18next';
import { IonIcon } from '@ionic/react';
import InputAdornment from '@mui/material/InputAdornment';

import StyledTextField from '~config/MaterialUIStyles/TextField';

import styles from './styles.module.scss';

class InputLabel extends Component {
  handleChange = e => {
    const { onChangeFormik, onChange, maxLength, setFieldsError } = this.props;
    const { value } = e.target;
    setFieldsError && setFieldsError();
    if (!maxLength || value?.length <= maxLength) {
      onChangeFormik?.(e);
      onChange?.(e);
    }
  };

  render() {
    const {
      actions,
      className,
      icon,
      errorClassName,
      name,
      label,
      placeholder,
      inputType,
      onFocus,
      onBlur,
      onKeyPress,
      disabled,
      value,
      error,
      isFocused,
      showError,
      readOnly,
      iconClassName,
      fieldRef,
      isTextarea,
      inputContainerClassName,
      showCounter,
      maxLength,
      sx,
      helperText,
      aditionalsInputProps,
      extraError
    } = this.props;
    const renderCounter = !error && maxLength && showCounter;
    const charactersLeft = maxLength - value?.length;
    const inputProps = {
      ...(icon
        ? {
            startAdornment: (
              <InputAdornment position="start">
                <IonIcon
                  size="large"
                  className={`m-right-2 text-emperor ${styles.icon} ${iconClassName}`}
                  icon={icon}
                />
              </InputAdornment>
            )
          }
        : {}),
      ...(actions
        ? {
            endAdornment: <InputAdornment position="end">{actions}</InputAdornment>
          }
        : {}),
      ...aditionalsInputProps
    };

    return (
      <div
        className={cn('column', styles.container, className, {
          [styles.error]: error || extraError,
          [styles.focused]: isFocused,
          [errorClassName]: error
        })}>
        <div className={`row text-base ${styles.inputContainer} ${inputContainerClassName}`}>
          <StyledTextField
            className={cn('row full-width', {
              [styles.noResize]: isTextarea
            })}
            name={name}
            id={name}
            type={inputType}
            placeholder={placeholder}
            label={label}
            onChange={this.handleChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            disabled={disabled}
            value={value}
            readOnly={readOnly}
            sx={{ mb: '5px', mt: '5px', ...sx }}
            InputProps={inputProps}
            {...(fieldRef && { ref: fieldRef })}
            {...(isTextarea && { multiline: true, rows: 4 })}
            InputLabelProps={{
              shrink: isFocused || value?.length > 0,
              sx: { ...(!value && !isFocused && icon && { ml: '30px' }) }
            }}
          />
        </div>
        {renderCounter && (
          <p className={styles.counter}>{t('InputLabel:characterCount', { charactersLeft })}</p>
        )}
        {showError && <p className={styles.inputError}>{error}</p>}
        {extraError && extraError}
        {helperText ? <p className={styles.inputHelperText}>{helperText}</p> : null}
      </div>
    );
  }
}

InputLabel.propTypes = {
  inputType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  actions: PropTypes.element,
  aditionalsInputProps: object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorClassName: PropTypes.string,
  extraError: element,
  fieldRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  focusedClassName: PropTypes.string,
  helperText: PropTypes.string,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  iconComponent: element,
  inputClassName: PropTypes.string,
  inputContainerClassName: PropTypes.string,
  isFocused: PropTypes.bool,
  isTextarea: PropTypes.bool,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  labelContainerClassName: PropTypes.string,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  placeholderClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  setFieldsError: PropTypes.func,
  showCounter: PropTypes.bool,
  showError: PropTypes.bool,
  styledPlaceholder: PropTypes.bool,
  sx: PropTypes.shape({
    border: PropTypes.string
  }),
  textClassName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onChangeFormik: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyPress: PropTypes.func
};

InputLabel.defaultProps = {
  className: '',
  errorClassName: '',
  focusedClassName: '',
  iconClassName: '',
  inputClassName: '',
  inputContainerClassName: '',
  labelClassName: '',
  labelContainerClassName: '',
  placeholder: '',
  showCounter: false,
  showError: true,
  textClassName: '',
  value: ''
};

export default InputLabel;
